/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import { BlankEnum } from './blankEnum';
import { UnitEnum } from './unitEnum';

export const SampleBreakdownUnit = {...UnitEnum,...BlankEnum,} as const